/* eslint-disable no-restricted-syntax */
import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'

import { BASE_FONT_SIZE } from './constants'
import { space, color, font, fontWeight, fontSize } from './utils'

export const GlobalStyle = createGlobalStyle`
  ${normalize};

  #root {
    margin: 0 auto;

    // large screen navigation overlay
    &:before,
    &:after {
      background-image: linear-gradient(90deg, rgba(28,28, 28, 1) 85%, rgba(28,28, 28, 0.1) 100%);
      content: '';
      height: 100vh;
      position: fixed;
      z-index: 1000;
      top:0;
      bottom: 0;
      width: calc((100% - 1280px) / 2);
    }

    &:before {
      left: 0
    }

    &:after {
      right: 0;
      background-image: linear-gradient(270deg, rgba(28,28, 28, 1) 85%, rgba(28,28, 28, 0.1) 100%);

    }

  }

  *, *:before, *:after {
    box-sizing: border-box;
    user-select:none;
  }

  html, body{
    min-height: 100vh;
    min-height: var(--vh);
    min-height: 100dvh;
    text-size-adjust: none;
  }

  html {
    font-size: ${BASE_FONT_SIZE}px;
    overscroll-behavior: none;
  }
  body {
    /* scrollbar-gutter: stable; */
    /* overflow-y: scroll; */
  }

  .animation--overflow--hidden {
    overflow-x: hidden;
    overflow-y: hidden;
    // Do this to prevent mid navigation animation interactions because we don't want that jank.
    pointer-events: none;
  }

  .overflow--hidden{
    overflow:hidden;
  }


  figure, fieldset {
    padding:0;
    margin:0;
  }

  fieldset{
    border: 0;
  }
  
  button {
    cursor: pointer;
    background:none;
    border:0;
  }
  
  li {
    margin:0 0 1rem 0;
  }

  hr {
    height:0;
    margin: 1rem 0;
    width:100%;
    border-bottom:2px solid ${color('primaryText')};
  }

  body { 
    font-family: ${font('base')};
    font-weight: ${fontWeight('base')};
    background: ${color('background')};
    color: ${color('primaryText')};
    letter-spacing: 0.05rem;
    line-height: 1.5;
    
    > svg{
      visibility: hidden;
      height:0;
      width:0;
      display:none;
    }
  }

  p {
    line-height: 1.5;
    margin: 0 0 1rem 0;
  }

  a {
    color: ${color('interactive')};
    text-decoration: none;
    border-radius: ${space(1)};
  }

  ul, ol {
    margin: 0 0 1rem 0;
    padding: 0 0 0 1rem;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${color('primaryText')};
    font-family: ${font('base')};
    font-weight: ${fontWeight('base')};
    margin:0;
  }
  
  h2 {
    font-size: ${fontSize('m')};
  }

  h3 {
    font-size: ${fontSize('s')};
  }

  .no-js-message{
    text-align:center;
    padding:20px;
    background: salmon;
    margin: 0 20px;
    border-radius: 4px;
    border: 1px solid salmon;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.08);
  }

  // Loading Screen
  .loading-screen-wrap {
    position:relative;
    z-index: 100;
  }

  .error-fallback,
  .fourOhFour {
    position: absolute;
    z-index: 200;
    background-color: ${color('background')};
    background-image: url('./assets/404.jpg');
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    will-change: opacity;
    z-index: 200;
    display:flex;
    flex-direction: column;
    display: flex;
    > div{
      display:flex;
      flex-direction: column;
      padding: ${space(10)} ${space(4)};
      background: rgba(0,0,0,0.5);
    }
    button,
    a {
      margin: 0 auto;
      min-width: 25%;
    }
    text-align: center;
    align-content: center;
    justify-content: center;
  }

  .loading-screen {
    --scale: 2;
    --offsetValue: 26px;
    --offset: calc(var(--offsetValue) * -1);
    --startRotate: 0deg;
    --endRotate: 360deg;

    @keyframes spinScale {
      0% {
        transform: scale(1) rotate(var(--startRotate));
        color: ${color('border')};
        top: 20px;
        left: 0;
      }
      21%,
      29% {
        transform: scale(var(--scale)) rotate(180deg);
        color: ${color('accent')};
        top: 0;
        left: var(--offset);
      }
      50% {
        transform: scale(1) rotate(var(--endRotate));
        color: ${color('border')};
        top: 20px;
        left: 0;
      }
      100% {
        transform: scale(1) rotate(var(--endRotate));
        color: ${color('border')};
        top: 20px;
        left: 0;
      }
    }
    min-height: 100vh;
    min-height: 100dvh;
    position: absolute;
    z-index: 200;
    background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 1) 0%,
          ${color('background')} 30%
        );
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    will-change: opacity;
    z-index: 200;
    display:flex;
    flex-direction: row;
    gap: ${space(4)};
    padding: ${space(15)} ${space(8)};
    justify-content: center;
    align-items: center;
    color: ${color('border')};

    span {
      position: absolute;
      top: 40%;
      color: ${color('primaryText')};
    }
    
    svg {
      fill: currentColor;
      position: relative;
    }
    svg:first-child {
      --startRotate: 360deg;
      --endRotate: 0deg;
      animation: spinScale 4s infinite ease-in-out;
    }
    svg:first-child + svg {
      --offset: var(--offsetValue);
      fill: currentColor;
      animation: spinScale 4s 250ms infinite ease-in-out;
    }

    @media only screen and (min-width: 650px) {
      --scale: 3;
      --offsetValue: 50px
    }
  }

  // Image placeholder/loader
  @keyframes pulse {
    0% {
      opacity:0.1;
    }
    
    50% {
      opacity:0.15;
    }
    
    100% {
      opacity:0.1;
    }
  }

  .pageLoad,
  .image-placeholder {
    // Book.svg
    background-image: url("data:image/svg+xml;base64,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");
    background-repeat: no-repeat;
    background-size: 100px;
    background-position: center;
  }

  .image-placeholder.error {
    // Book.svg in error color
    background-image: url("data:image/svg+xml;base64,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");
    background-repeat: no-repeat;
    background-size: 100px;
    background-position: center;
  }

  .pageLoad,
  .image-placeholder {
    will-change: opacity;
    animation: pulse 1500ms infinite ease-in-out;
  }

  .pageLoad {
    width: 100%;
    min-height: var(--vh, 100%);
  }

  .image-placeholder:not(.loaded) {
    aspect-ratio: 0.66/ 1;
  }

  .image-placeholder.loaded,
  .image-placeholder.error {
    opacity: 1;
    animation: none;
    background-color: unset;
  }

  .image-placeholder.loaded {
    background-image: none;
  }

  .image-placeholder.error {
    position: relative;
    &:after {
      color: ${color('error')};
      content: 'Image not found';
      justify-content: center;
      font-size: ${fontSize('s')};
      width: 100%;
      text-align: center;
      display:flex;
      top: 80%;
      position: absolute;
      
    }
  }

  #modal-root {
    position: relative;
    z-index: 1000;
  }
`
